import React, { useState } from 'react';
import unsplash from '../api/unsplash';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    DialogActions,
    Grid,
    Zoom,
    Paper,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from '@mui/material';

import { Euro, People, Badge } from '@mui/icons-material';
import GlobalSnackbar from './Snackbar';
import { Close } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const datiPacchetti = {
    1: { Nome: 'Starter' },
    2: { Nome: 'Professional' },
    3: { Nome: 'Enterprise' },
};

const Consumi = (props) => {
    const [open, setOpen] = useState(false);
    const [settings, setSettings] = useState(null);
    const [totaleLavoratori, setTotaleLavoratori] = useState(0);
    const [totaleAmbienti, setTotaleAmbienti] = useState(0);
    const [totaleUtenti, setTotaleUtenti] = useState(0);
    const [openSnack, setOpenSnack] = useState(false);
    const snack = {
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    };
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    const handleClickOpen = async () => {
        let response = await unsplash.get('settings', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        setSettings(response.data.data[0]);

        let responsePanoramica = await unsplash.get('settings/panoramica', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });

        setTotaleLavoratori(responsePanoramica.data.data.TotLavoratori);
        setTotaleUtenti(responsePanoramica.data.data.TotUtenti);
        setTotaleAmbienti(responsePanoramica.data.data.TotAmbienti);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    //p[index].IDAggiuntivo = null;

    return (
        <>
            <Button
                startIcon={<Euro />}
                className="ButtonMiller"
                fullWidth
                variant="contained"
                onClick={handleClickOpen}
            >
                Panoramica
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="sm"
                TransitionComponent={Transition}
            >
                <GlobalSnackbar
                    severity={snack.severity}
                    messaggio={snack.messaggio}
                    openSnack={openSnack}
                    handleCloseSnack={handleCloseSnack}
                />
                <DialogTitle>Panoramica </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Paper
                                sx={{
                                    p: 2,
                                    background: '#11526F',
                                    color: 'white',
                                    justifyContent: 'center',
                                    display: 'flex',
                                }}
                                elevation={0}
                            >
                                {'Pacchetto ' +
                                    datiPacchetti[
                                        settings ? settings.Pacchetto : 1
                                    ].Nome}
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper
                                sx={{
                                    p: 2,
                                    background: '#11526F',
                                    color: 'white',
                                }}
                                elevation={0}
                            >
                                <List sx={{ py: 0 }}>
                                    <ListItem
                                        alignItems="center"
                                        disableGutters
                                        sx={{ py: 0 }}
                                    >
                                        <ListItemAvatar>
                                            <Badge />
                                        </ListItemAvatar>
                                        <ListItemText
                                            sx={{ py: 0 }}
                                            secondaryTypographyProps={{
                                                color: 'white',
                                            }}
                                            primary={totaleLavoratori}
                                            secondary={'Lavoratori'}
                                        />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper
                                sx={{
                                    p: 2,
                                    background: '#11526F',
                                    color: 'white',
                                }}
                                elevation={0}
                            >
                                <List sx={{ py: 0 }}>
                                    <ListItem
                                        alignItems="center"
                                        disableGutters
                                        sx={{ py: 0 }}
                                    >
                                        <ListItemAvatar>
                                            <People />
                                        </ListItemAvatar>
                                        <ListItemText
                                            sx={{ py: 0 }}
                                            secondaryTypographyProps={{
                                                color: 'white',
                                            }}
                                            primary={totaleUtenti}
                                            secondary={'Utenti'}
                                        />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper
                                sx={{
                                    p: 2,
                                    background: '#11526F',
                                    color: 'white',
                                }}
                                elevation={0}
                            >
                                <List sx={{ py: 0 }}>
                                    <ListItem
                                        alignItems="center"
                                        disableGutters
                                        sx={{ py: 0 }}
                                    >
                                        <ListItemAvatar>
                                            <People />
                                        </ListItemAvatar>
                                        <ListItemText
                                            sx={{ py: 0 }}
                                            secondaryTypographyProps={{
                                                color: 'white',
                                            }}
                                            primary={totaleAmbienti}
                                            secondary={'Ambienti'}
                                        />
                                    </ListItem>
                                </List>
                            </Paper>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    sx={{
                        marginLeft: 2,
                        marginRight: 'auto',
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Button
                        onClick={handleClose}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Close />}
                    >
                        Chiudi
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default Consumi;
